import { render } from "./AgeGenderMaterialChartPanel.vue?vue&type=template&id=2c965752&scoped=true"
import script from "./AgeGenderMaterialChartPanel.vue?vue&type=script&lang=js"
export * from "./AgeGenderMaterialChartPanel.vue?vue&type=script&lang=js"

import "./AgeGenderMaterialChartPanel.vue?vue&type=style&index=0&id=2c965752&lang=css&scoped=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c965752"]])

export default __exports__